<template>
    <div class="details">
        <div class="score">
            <div class="left">
                <div class="scoreTitle">本次作业评分</div>
                <div class="scoreDes">{{ `本次作业总得分（满分${commentData.total}）` }}</div>
            </div>
            <div class="right">
                <div class="scoreNum">{{ commentData.user_score }}</div>
                <div class="scoreDes">分</div>
            </div>
        </div>
        <div class="comment common" v-if="commentData.comment">
            <div class="commonTitle">教师评语：</div>
            <div class="commentContent">
                {{ commentData.comment || '暂无评语' }}
            </div>
            <div class="commentFile">
                <div class="attachment-item" v-for="(item,index) of commentData.files" :key="index" @click="downloadFile(item.url)" >
                    <img class="file-icon" :src="require(`@/assets/images/homeWork/${getFileType(item.title)}.png`)" />
                    <div class="upload-status">
                        <div class="attachment-name">
                            <span class="front">{{ item.title.split('.')[0] }}</span>
                            <span>.{{ item.title.split('.')[1] }}</span>
                        </div>
                        <div class="progress" v-if="item.size">
                        <span>{{item.size}}M</span>
                        </div>
                        <div class="progress" v-else-if="item.progress">
                            <span>{{(item.progress.total/(1024*1024)).toFixed(2)}}M</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="common answerSheets">
            <answerSheet :questionList="questionList" :modeType="2" :isShowCurrent="false" :isShowSubmit="false" @handleClick="answerSheetClick">
                <div slot="title" class="commonTitle">答题卡</div>
            </answerSheet>
        </div>
    </div>
</template>

<script>
import answerSheet from './answerSheet.vue'
import { getFileType } from '@/utils/index.js'
export default {
    name: "DetailsComponent",
    components: {
        answerSheet
    },
    props: {
        commentData: {
            type: Object,
            default: () => ({})
        },
        questionList: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        getFileType,
        downloadFile(url) {
            window.open(url);
        },
        answerSheetClick(item, index) {
            this.$emit("answerSheetClick", item, index);
        }
    }
};
</script>

<style lang="scss" scoped>
.details {
    padding: 12px;
    box-sizing: border-box;
    height: calc(100vh - 42px);
    background-color: rgba(0,0,0,0.05);
    display: flex;
    flex-direction: column;
    .score {
        background: url("~@/assets/images/homeWork/detailBg.png") no-repeat;
        background-size: 100% 100%;
        height: 100px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #ffffff;
        border-radius: 8px;
        padding: 0 12px;
        box-sizing: border-box;
        .left {
            .scoreTitle {
                font-size: 20px;
                color: #202020;
                font-weight: 600;
            }
            .scoreDes {
                font-size: 14px;
                color: #666666;
                margin-top: 4px;
            }
        }
        .right {
            display: flex;
            align-items: flex-end;
            .scoreNum {
                font-size: 40px;
                color: #286BFF;
                font-weight: 700;
            }
            .scoreDes {
                font-size: 14px;
                color: #666666;
                margin-left: 4px;
                margin-bottom: 8px;
            }
        }
    }
    .comment {
        color: #202020;
        font-size: 14px;
        margin-top: 12px;
        .commentContent {
            margin-top: 8px;
            word-break: break-all;
            white-space: pre-wrap;
        }
        .commentFile {
            .attachment-item{
                // height: 64px;
                background: #F4F6F6;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding: 4px 6px 4px 4px;
                margin-top: 8px;
                border-radius: 8px;
                width: 100%;
                box-sizing: border-box;
                .attachment-name{
                    overflow:hidden;
                    text-overflow:ellipsis;
                    white-space:nowrap;
                    display: flex;
                    align-items: center;
                    .front {
                        display: inline-block;
                        max-width: 220px;
                        overflow:hidden;
                        text-overflow:ellipsis;
                        white-space:nowrap
                    }
                }
                .file-icon{
                    width: 24px;
                    height: 24px;
                    margin-right: 4px;
                }
                .upload-status{
                display: flex;
                flex:1;
                align-items: center;
                .progress{
                    display: flex;
                    align-items: center;
                    margin-left: auto;
                    ::v-deep .el-progress-bar__outer{
                    background-color:#ffffff;
                    }
                    span{
                    font-size: 12px;
                    color: #888888;
                    }
                }
                }
                .close-icon{
                width: 16px;
                height: 16px;
                margin-left: auto;
                cursor: pointer;
                }
            }
        }
    }
    .answerSheets {
        flex: 1;
        margin-top: 12px;
        overflow-y: auto;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
            display: none; /* Safari 和 Chrome */
        }
    }

    .common {
        padding: 12px;
        box-sizing: border-box;
        background-color: #ffffff;
        border-radius: 8px;
        .commonTitle {
            color: #202020;
            font-size: 16px;
            position: relative;
            padding-left: 8px;
            font-weight: 400;
            &::before {
                content: "";
                position: absolute;
                width: 4px;
                height: 12px;
                background: #286BFF;
                border-radius: 2px;
                left: 0;
                top: calc(50% - 6px);
            }
        }
    }
}
</style>